/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuctionCatalogHierarchyDataDto } from '../../models/auction-catalog-hierarchy-data-dto';
import { AuctionCatalogHierarchyDto } from '../../models/auction-catalog-hierarchy-dto';

export interface CreateAuctionCatalogs$Params {
  auctionId: number;
  'X-API-Version'?: string;
      body: AuctionCatalogHierarchyDataDto
}

export function createAuctionCatalogs(http: HttpClient, rootUrl: string, params: CreateAuctionCatalogs$Params, context?: HttpContext): Observable<StrictHttpResponse<AuctionCatalogHierarchyDto>> {
  const rb = new RequestBuilder(rootUrl, createAuctionCatalogs.PATH, 'post');
  if (params) {
    rb.query('auctionId', params.auctionId, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuctionCatalogHierarchyDto>;
    })
  );
}

createAuctionCatalogs.PATH = '/api/auction-catalogs';
